import { useEffect, useState } from 'react';
import AdminLayout from '../components/AdminLayout.jsx';
import { api } from '../../api/client.js';
import { Swal2 } from '../../lib/swal.js';
import { MORPH_BTN, MORPH_BTN_SM } from '../../lib/ui.js';

const empty = { layanan_id: '', nama_klien: '', institusi: '', tanggal_acara: '', jam_mulai: '', jam_selesai: '', status: 'confirmed', catatan: '', is_public: true };

export default function BookingList() {
  const [items, setItems] = useState(null);
  const [layananList, setLayananList] = useState([]);
  const [modal, setModal] = useState(null); // null | 'new' | booking object
  const [form, setForm] = useState(empty);
  const [error, setError] = useState('');

  const load = () => api.get('/admin/booking').then(({ data }) => setItems(data.items));
  useEffect(() => {
    load();
    api.get('/admin/layanan').then(({ data }) => setLayananList(data.items));
  }, []);

  const openNew = () => { setForm(empty); setError(''); setModal('new'); };
  const openEdit = (b) => {
    setForm({
      ...b,
      tanggal_acara: b.tanggal_acara,
      jam_mulai: b.jam_mulai?.slice(0, 5),
      jam_selesai: b.jam_selesai?.slice(0, 5),
      is_public: !!b.is_public,
    });
    setError('');
    setModal(b);
  };

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      if (modal === 'new') await api.post('/admin/booking', form);
      else await api.put(`/admin/booking/${modal.id}`, form);
      setModal(null);
      Swal2.toast('success', modal === 'new' ? 'Booking berhasil ditambahkan.' : 'Booking berhasil diperbarui.');
      load();
    } catch (err) {
      setError(err.response?.data?.message || 'Gagal menyimpan.');
    }
  };

  const remove = async (id, nama) => {
    const confirmed = await Swal2.confirmDelete(nama || 'jadwal ini');
    if (!confirmed) return;
    await api.delete(`/admin/booking/${id}`);
    setModal(null);
    Swal2.toast('success', 'Booking berhasil dihapus.');
    load();
  };

  const inputCls = 'w-full px-4 py-3 rounded-xl border text-sm outline-none bg-neutral-50 dark:bg-neutral-800 dark:text-white border-neutral-200 dark:border-neutral-700 focus:border-forest-500 focus:ring-2 focus:ring-forest-500/20';
  const labelCls = 'block text-xs font-bold text-neutral-500 uppercase tracking-wider mb-1.5';

  const statusColor = { confirmed: 'bg-green-50 text-green-600', pending: 'bg-amber-50 text-amber-600', cancelled: 'bg-red-50 text-red-500' };

  return (
    <AdminLayout title="Jadwal Booking">
      <div className="flex justify-end mb-4">
        <button onClick={openNew} className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-xl font-bold text-white text-sm ${MORPH_BTN_SM}`} style={{ background: 'var(--accent)' }}>
          <span className="material-symbols-outlined text-base">add</span> Tambah Booking
        </button>
      </div>

      <div className="rounded-2xl border bg-white dark:bg-neutral-900 border-black/5 dark:border-white/5 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-neutral-50 dark:bg-neutral-800 text-left text-xs uppercase text-neutral-500">
            <tr>
              <th className="px-4 py-3">Klien</th>
              <th className="px-4 py-3">Layanan</th>
              <th className="px-4 py-3">Tanggal</th>
              <th className="px-4 py-3">Jam</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Publik</th>
              <th className="px-4 py-3 text-right">Aksi</th>
            </tr>
          </thead>
          <tbody>
            {items === null && <tr><td colSpan={7} className="px-4 py-6 text-neutral-400">Memuat...</td></tr>}
            {items?.length === 0 && <tr><td colSpan={7} className="px-4 py-6 text-neutral-400">Belum ada booking.</td></tr>}
            {items?.map((b) => (
              <tr key={b.id} className="border-t border-neutral-100 dark:border-neutral-800">
                <td className="px-4 py-3 font-semibold text-neutral-900 dark:text-white">{b.nama_klien}<div className="text-xs text-neutral-400 font-normal">{b.institusi}</div></td>
                <td className="px-4 py-3 text-neutral-500">{b.layanan_nama || '-'}</td>
                <td className="px-4 py-3 text-neutral-500">{b.tanggal_acara}</td>
                <td className="px-4 py-3 text-neutral-500">{b.jam_mulai?.slice(0, 5)}-{b.jam_selesai?.slice(0, 5)}</td>
                <td className="px-4 py-3"><span className={`text-xs font-bold px-2 py-0.5 rounded-full ${statusColor[b.status]}`}>{b.status}</span></td>
                <td className="px-4 py-3">{b.is_public ? <span className="material-symbols-outlined text-forest-500 text-base">visibility</span> : <span className="material-symbols-outlined text-neutral-300 text-base">visibility_off</span>}</td>
                <td className="px-4 py-3 text-right space-x-2 whitespace-nowrap">
                  <button onClick={() => openEdit(b)} className={`text-xs font-semibold px-3 py-1.5 rounded-lg bg-neutral-100 dark:bg-neutral-800 text-neutral-600 dark:text-white hover:bg-neutral-200 dark:hover:bg-neutral-700 ${MORPH_BTN_SM}`}>Edit</button>
                  <button onClick={() => remove(b.id, b.nama_klien)} className={`text-xs font-semibold px-3 py-1.5 rounded-lg bg-red-50 text-red-500 dark:bg-red-950/30 ${MORPH_BTN_SM}`}>Hapus</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/50" onClick={() => setModal(null)}>
          <form onSubmit={submit} onClick={(e) => e.stopPropagation()} className="w-full max-w-lg bg-white dark:bg-neutral-900 rounded-2xl p-6 space-y-4 max-h-[90vh] overflow-y-auto">
            <h3 className="font-display font-bold text-lg text-neutral-900 dark:text-white">{modal === 'new' ? 'Tambah Booking' : 'Edit Booking'}</h3>
            {error && <div className="p-3 rounded-xl text-sm font-semibold bg-red-50 text-red-600">{error}</div>}
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className={labelCls}>Nama Klien</label>
                <input required className={inputCls} value={form.nama_klien} onChange={set('nama_klien')} />
              </div>
              <div>
                <label className={labelCls}>Institusi</label>
                <input className={inputCls} value={form.institusi || ''} onChange={set('institusi')} />
              </div>
            </div>
            <div>
              <label className={labelCls}>Layanan</label>
              <select className={inputCls} value={form.layanan_id || ''} onChange={set('layanan_id')}>
                <option value="">Pilih layanan</option>
                {layananList.map((l) => <option key={l.id} value={l.id}>{l.nama}</option>)}
              </select>
            </div>
            <div className="grid grid-cols-3 gap-4">
              <div>
                <label className={labelCls}>Tanggal</label>
                <input required type="date" className={inputCls} value={form.tanggal_acara} onChange={set('tanggal_acara')} />
              </div>
              <div>
                <label className={labelCls}>Jam Mulai</label>
                <input required type="time" className={inputCls} value={form.jam_mulai} onChange={set('jam_mulai')} />
              </div>
              <div>
                <label className={labelCls}>Jam Selesai</label>
                <input required type="time" className={inputCls} value={form.jam_selesai} onChange={set('jam_selesai')} />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4 items-end">
              <div>
                <label className={labelCls}>Status</label>
                <select className={inputCls} value={form.status} onChange={set('status')}>
                  <option value="confirmed">Confirmed</option>
                  <option value="pending">Pending</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </div>
              <label className="flex items-center gap-2 pb-3 text-sm font-semibold text-neutral-700 dark:text-white">
                <input type="checkbox" checked={form.is_public} onChange={(e) => setForm((f) => ({ ...f, is_public: e.target.checked }))} className="w-4 h-4 accent-forest-500" />
                Tampilkan di halaman publik
              </label>
            </div>
            <div>
              <label className={labelCls}>Catatan</label>
              <textarea rows={2} className={`${inputCls} resize-none`} value={form.catatan || ''} onChange={set('catatan')} />
            </div>
            <div className="flex gap-3 pt-2">
              <button type="submit" className={`px-6 py-3 rounded-xl font-bold text-white text-sm ${MORPH_BTN}`} style={{ background: 'var(--accent)' }}>Simpan</button>
              <button type="button" onClick={() => setModal(null)} className={`px-6 py-3 rounded-xl font-bold text-sm bg-neutral-100 dark:bg-neutral-800 text-neutral-600 dark:text-white ${MORPH_BTN}`}>Batal</button>
            </div>
          </form>
        </div>
      )}
    </AdminLayout>
  );
}
